import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "container-lg" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-3 col-12" }
const _hoisted_4 = { class: "card mt-3" }
const _hoisted_5 = { class: "card-group-item" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "Filtre")
], -1)
const _hoisted_7 = { class: "filter-content" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "form-check small" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label" }, " Ingen billeder ", -1)
const _hoisted_13 = {
  key: 0,
  class: "card mt-3"
}
const _hoisted_14 = { class: "card mt-3" }
const _hoisted_15 = { class: "card-group-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("header", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "title" }, "Kilder")
], -1)
const _hoisted_17 = { class: "filter-content" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "form-check small" }
const _hoisted_22 = ["id", "value"]
const _hoisted_23 = { class: "form-check-label" }
const _hoisted_24 = { class: "card mt-3" }
const _hoisted_25 = { class: "card-group-item" }
const _hoisted_26 = { class: "card-header" }
const _hoisted_27 = { class: "title" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", null, "Temaer", -1)
const _hoisted_29 = { class: "float-end" }
const _hoisted_30 = { class: "filter-content" }
const _hoisted_31 = { class: "card-body" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "form-check ms-1 small" }
const _hoisted_34 = ["id", "value"]
const _hoisted_35 = { class: "form-check-label" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "form-check small" }
const _hoisted_39 = ["id", "value"]
const _hoisted_40 = { class: "form-check-label" }
const _hoisted_41 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_42 = { class: "col" }
const _hoisted_43 = { class: "container mt-3" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = ["onKeypress"]
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "d-flex" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 0,
  class: "shadow-sm col-1 position-relative"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = ["src", "alt"]
const _hoisted_53 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = {
  key: 0,
  class: "shadow-sm col-1 position-relative"
}
const _hoisted_56 = { key: 0 }
const _hoisted_57 = ["src", "alt"]
const _hoisted_58 = {
  key: 1,
  class: "container-fluid"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "text-end" }, "Nulstil filtre", -1)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = { class: "row mt-1" }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1)
const _hoisted_64 = [
  _hoisted_63
]

import {
  FIGURER_OPSLAG,
  KILDER_OPSLAG,
  KLODS_FOR_UUID_OPSLAG,
  TEMAER_OPSLAG
} from "@/constants/graphql";
import {
  computed,
  inject,
  onBeforeMount,
  onMounted,
  Ref,
  ref,
  watch
} from "vue";
import { useQuery, useResult } from "@vue/apollo-composable";
import TemaElement from "@/components/base/TemaElement.vue";
import { onBeforeRouteLeave } from "vue-router";
import LegoSetCard from "@/components/LegoSetCard.vue";
import { useAuth0 } from "@auth0/auth0-vue";
import Lokationsfilter from "@/components/Lokationsfilter.vue";
import gql from "graphql-tag";
import { Legosaet } from "@/types/legotyper";
import { WebDAVClient } from "webdav";

interface KildeVariable {
  kilder: string[] | undefined;
}
interface LokationVariable {
  lokationer: string[] | undefined;
}
interface TemaVariable {
  singletema00: string | undefined;
  singletema01: string | undefined;
  singletema02: string | undefined;
  singletema03: string | undefined;
  singletema04: string | undefined;
  singletema05: string | undefined;
  singletema06: string | undefined;
  singletema07: string | undefined;
  singletema08: string | undefined;
  singletema09: string | undefined;
  count00: number | undefined;
  count01: number | undefined;
  count02: number | undefined;
  count03: number | undefined;
  count04: number | undefined;
  count05: number | undefined;
  count06: number | undefined;
  count07: number | undefined;
  count08: number | undefined;
  count09: number | undefined;
  hovedtema00: string | undefined;
  hovedtema01: string | undefined;
  hovedtema02: string | undefined;
  hovedtema03: string | undefined;
  hovedtema04: string | undefined;
  hovedtema05: string | undefined;
  hovedtema06: string | undefined;
  hovedtema07: string | undefined;
  hovedtema08: string | undefined;
  hovedtema09: string | undefined;
  undertema00: string | undefined;
  undertema01: string | undefined;
  undertema02: string | undefined;
  undertema03: string | undefined;
  undertema04: string | undefined;
  undertema05: string | undefined;
  undertema06: string | undefined;
  undertema07: string | undefined;
  undertema08: string | undefined;
  undertema09: string | undefined;
}
interface SaetVariable extends TemaVariable, KildeVariable, LokationVariable {
  soegetekst: string | undefined;
  uuid?: string;
}

interface Filter {
  checkMapper: boolean;
  soegetekst: string;
  kilder: string[];
  klodsUuid?: string;
  minifigUuid?: string;
  lokationer: string[];
  temaer: string[];
  max: number;
}
interface Variables {
  uuid: string;
}
interface Options {
  enabled: boolean;
}
interface Inventory {
  inventory: Legosaet[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LegoInventory',
  props: {
    klodsUuid: null,
    lokation: null,
    minifigUuid: null
  },
  setup(__props: any) {

const props = __props as {
  klodsUuid?: string;
  lokation?: string;
  minifigUuid?: string;
}

const webdav = inject("webdavclient") as WebDAVClient;


const searchValue = ref("");

function defaultFilter(): Filter {
  return {
    checkMapper: false,
    kilder: [],
    lokationer: [],
    max: 100,
    soegetekst: "",
    klodsUuid: undefined,
    minifigUuid: undefined,
    temaer: []
  };
}

const filter: Ref<Filter> = ref({
  ...defaultFilter(),
  lokationer: props.lokation != undefined ? [props.lokation] : []
});
const filterKey = "legoinventory.filter";

const egneBilleder: Ref<string[]> = ref([]);

const accesstoken: Ref<string | undefined> = ref(undefined);

const { result: kilderResult, loading: kilderLoading } = useQuery(
  KILDER_OPSLAG,
  {},
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      accesstoken.value != undefined && accesstoken.value.trim().length > 0;
    options.enabled = enabled;
    return options;
  }
);
const { result: alleTemaer } = useQuery(TEMAER_OPSLAG);
const { result: saetResult, loading: saetLoading } = useQuery<Inventory>(
  () => {
    let saetOpslagVariable = ``;
    let saetOpslagParameterWhereAndBlok = ``;
    let saetOpslagParameterWhereOrInnerBlok = ``;

    if (filter.value.soegetekst) {
      saetOpslagVariable += `$soegetekst: String\n`;
      saetOpslagParameterWhereAndBlok += `{ OR: [{ nummer: $soegetekst }, { navn_MATCHES: $soegetekst }] }\n`;
    }
    if (filter.value.klodsUuid != undefined) {
      saetOpslagVariable += `$klodsuuid: ID\n`;
      saetOpslagParameterWhereAndBlok += `{ OR: [
        { indeholderKlods_SINGLE: { uuid: $klodsuuid } }
        { indeholderFigurs_SINGLE: { bestaarAfKlods_SINGLE: { uuid: $klodsuuid }}}
      ]}`;
    }
    if (filter.value.minifigUuid != undefined) {
      saetOpslagVariable += `$minifiguuid: ID\n`;
      saetOpslagParameterWhereAndBlok += `{ indeholderFigurs_SINGLE: { uuid: $minifiguuid } }`;
    }
    if (filter.value.lokationer.length > 0) {
      saetOpslagVariable += `$lokationer: [String!]\n`;
      saetOpslagParameterWhereAndBlok += `{ placeretLokations_SOME: { navn_IN: $lokationer } }\n`;
    }
    if (filter.value.kilder.length > 0) {
      saetOpslagVariable += `$kilder: [String!]\n`;
      saetOpslagParameterWhereAndBlok += `{ kildesHarSet_SOME: { navn_IN: $kilder } }\n`;
    }
    if (filter.value.temaer.length > 0) {
      saetOpslagParameterWhereOrInnerBlok = `{ OR: [\n`;
      let st = 0;
      let hu = 0;
      for (const tema of filter.value.temaer) {
        const temaliste = tema.split(">");
        if (temaliste.length == 1) {
          const stNummer = `0` + st++;
          saetOpslagVariable += `$singletema` + stNummer + `: String\n`;
          saetOpslagVariable += `$count` + stNummer + `: Int\n`;
          saetOpslagParameterWhereOrInnerBlok +=
            `{ harTemaTemas_SINGLE: { AND: [
            { navn: $singletema` +
            stNummer +
            `}
            { undertemaTilTemasAggregate: { count: $count` +
            stNummer +
            ` } }
          ]}}
          `;
        } else {
          const huNummer = `0` + hu++;
          saetOpslagVariable += `$undertema` + huNummer + `: String\n`;
          saetOpslagVariable += `$hovedtema` + huNummer + `: String\n`;
          saetOpslagParameterWhereOrInnerBlok +=
            `{ harTemaTemas_SINGLE: { AND: [
            { navn: $undertema` +
            huNummer +
            `}
            { undertemaTilTemas_SINGLE: { navn: $hovedtema` +
            huNummer +
            ` } }
          ]}}
          `;
        }
      }
      saetOpslagParameterWhereOrInnerBlok += `]}\n`;
    }
    saetOpslagVariable += `$max: Int!\n`;

    const saetUdtryk = `query seatOpslag(
      ${saetOpslagVariable}
  ) {
    inventory: sets(
      where: {
        AND: [
          ${saetOpslagParameterWhereAndBlok}
          ${saetOpslagParameterWhereOrInnerBlok}
        ]
      }
      options: { limit: $max }
    ) {
      uuid
      nummer
      navn
      aarstal
      version
      kommentar
      fotograferet
      url
      antalKlodser
      harTemaTemas {
        id
        navn
        undertemaTilTemas {
          id
          navn
          __typename
        }
        __typename
      }
      kildesHarSetConnection {
        edges {
          antal
          __typename
        }
        __typename
      }
      __typename
    }
  }`;
    return gql(saetUdtryk);
  },
  () => {
    const variables: SaetVariable = {
      lokationer: undefined,
      kilder: undefined,
      soegetekst: undefined,
      singletema00: undefined,
      singletema01: undefined,
      singletema02: undefined,
      singletema03: undefined,
      singletema04: undefined,
      singletema05: undefined,
      singletema06: undefined,
      singletema07: undefined,
      singletema08: undefined,
      singletema09: undefined,
      count00: undefined,
      count01: undefined,
      count02: undefined,
      count03: undefined,
      count04: undefined,
      count05: undefined,
      count06: undefined,
      count07: undefined,
      count08: undefined,
      count09: undefined,
      hovedtema00: undefined,
      hovedtema01: undefined,
      hovedtema02: undefined,
      hovedtema03: undefined,
      hovedtema04: undefined,
      hovedtema05: undefined,
      hovedtema06: undefined,
      hovedtema07: undefined,
      hovedtema08: undefined,
      hovedtema09: undefined,
      undertema00: undefined,
      undertema01: undefined,
      undertema02: undefined,
      undertema03: undefined,
      undertema04: undefined,
      undertema05: undefined,
      undertema06: undefined,
      undertema07: undefined,
      undertema08: undefined,
      undertema09: undefined
    };
    if (filter.value.soegetekst) {
      variables.soegetekst = filter.value.soegetekst;
    }
    if (filter.value.lokationer.length > 0) {
      variables.lokationer = filter.value.lokationer;
    }
    if (filter.value.kilder.length > 0) {
      variables.kilder = [];
      for (const kilde of filter.value.kilder) {
        variables.kilder.push(kilde);
      }
    }
    if (filter.value.temaer.length > 0) {
      let st = 0;
      let hu = 0;
      for (const tema of filter.value.temaer) {
        const temaliste = tema.split(">");
        if (temaliste.length == 1) {
          switch (st++) {
            case 0:
              variables.singletema00 = temaliste[0];
              variables.count00 = 0;
              break;
            case 1:
              variables.singletema01 = temaliste[0];
              variables.count01 = 0;
              break;
            case 2:
              variables.singletema02 = temaliste[0];
              variables.count02 = 0;
              break;
            case 3:
              variables.singletema03 = temaliste[0];
              variables.count03 = 0;
              break;
            case 4:
              variables.singletema04 = temaliste[0];
              variables.count04 = 0;
              break;
            case 5:
              variables.singletema05 = temaliste[0];
              variables.count05 = 0;
              break;
            case 6:
              variables.singletema06 = temaliste[0];
              variables.count06 = 0;
              break;
            case 7:
              variables.singletema07 = temaliste[0];
              variables.count07 = 0;
              break;
            case 8:
              variables.singletema08 = temaliste[0];
              variables.count08 = 0;
              break;
            case 9:
              variables.singletema09 = temaliste[0];
              variables.count09 = 0;
              break;
            default:
              console.log("FEJL: For mange enkelttemaer angivet.");
          }
        } else {
          switch (hu++) {
            case 0:
              variables.undertema00 = temaliste[1];
              variables.hovedtema00 = temaliste[0];
              break;
            case 1:
              variables.undertema01 = temaliste[1];
              variables.hovedtema01 = temaliste[0];
              break;
            case 2:
              variables.undertema02 = temaliste[1];
              variables.hovedtema02 = temaliste[0];
              break;
            case 3:
              variables.undertema03 = temaliste[1];
              variables.hovedtema03 = temaliste[0];
              break;
            case 4:
              variables.undertema04 = temaliste[1];
              variables.hovedtema04 = temaliste[0];
              break;
            case 5:
              variables.undertema05 = temaliste[1];
              variables.hovedtema05 = temaliste[0];
              break;
            case 6:
              variables.undertema06 = temaliste[1];
              variables.hovedtema06 = temaliste[0];
              break;
            case 7:
              variables.undertema07 = temaliste[1];
              variables.hovedtema07 = temaliste[0];
              break;
            case 8:
              variables.undertema08 = temaliste[1];
              variables.hovedtema08 = temaliste[0];
              break;
            case 9:
              variables.undertema09 = temaliste[1];
              variables.hovedtema09 = temaliste[0];
              break;
            default:
              console.log("FEJL: For mange hoved/under-temaer angivet.");
          }
        }
      }
    }
    return {
      ...variables,
      max: filter.value.max,
      klodsuuid: filter.value.klodsUuid,
      minifiguuid: filter.value.minifigUuid
    };
  },
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      accesstoken.value != undefined && accesstoken.value.trim().length > 0;
    options.enabled = enabled;
    return options;
  }
);

const {
  result: klodsResult,
  loading: klodsLoading,
  error: klodsError
} = useQuery(
  KLODS_FOR_UUID_OPSLAG,
  () => {
    const variables: Variables = {
      uuid: filter.value.klodsUuid ? filter.value.klodsUuid : ""
    };
    return variables;
  },
  () => {
    const options: Options = {
      enabled: false
    };
    const enabled =
      filter.value.klodsUuid != undefined &&
      filter.value.klodsUuid.trim().length > 0;
    options.enabled = enabled;

    return options;
  }
);

const { result: minifigResult, loading: minifigLoading } = useQuery(
  FIGURER_OPSLAG,
  () => {
    const variables: Variables = {
      uuid: filter.value.minifigUuid ? filter.value.minifigUuid : ""
    };
    return variables;
  },
  () => {
    const options: Options = {
      enabled: false
    };
    const slaaetTil =
      filter.value.minifigUuid != undefined &&
      filter.value.minifigUuid.trim().length > 0;
    options.enabled = slaaetTil;

    return options;
  }
);

const inventory = useResult(saetResult, null, data => data.inventory);
const klods = useResult(klodsResult, null, data => data.klods[0]);
const minifig = useResult(minifigResult, null, data => data.figur[0]);
const temaer = useResult(alleTemaer, null, data => data.temaer);
const muligeKilder = useResult(kilderResult, null, data => data.muligeKilder);

function aktivtFilter(saet: Legosaet[], s: Legosaet): Legosaet[] {
  if (!filter.value.checkMapper || !egneBilleder.value.includes(s.nummer)) {
    saet.push(s);
  }
  return saet;
}
const filtreretOgSorteret = computed(() => {
  if (inventory.value !== null) {
    return inventory.value.reduce<Legosaet[]>(aktivtFilter, []);
  } else {
    return undefined;
  }
});

function soeg() {
  filter.value.soegetekst = searchValue.value;
}

function gemFiltre() {
  localStorage.setItem(filterKey, JSON.stringify(filter.value));
}
function nulstilAlleFiltre() {
  filter.value = defaultFilter();
  searchValue.value = "";
  gemFiltre();
}
function nulstilTemafilter() {
  filter.value.temaer = [];
}
function nulstilKlodsUuidFilter() {
  filter.value.klodsUuid = undefined;
}
function nulstilMinifigUuidFilter() {
  filter.value.minifigUuid = undefined;
}
function onEnter(event: KeyboardEvent) {
  soeg();
}

function checkbox(navn: string) {
  const indeks = filter.value.temaer.indexOf(navn);
  if (indeks > -1) {
    filter.value.temaer.splice(indeks, 1);
  } else {
    filter.value.temaer.push(navn);
  }
}

function opdaterLokationer(valgteLokationer: string[]) {
  filter.value.lokationer = valgteLokationer;
}

function vaelgTema(tema: { hovedtema: string; undertema: string }) {
  filter.value.temaer = [
    `${tema.hovedtema}${
      tema.undertema != undefined ? ">" + tema.undertema : ""
    }`
  ];
}

function klonFilter(filter: Filter, nytFilter: Filter) {
  nytFilter.checkMapper = filter.checkMapper;
  nytFilter.klodsUuid = filter.klodsUuid;
  nytFilter.max = filter.max;
  nytFilter.minifigUuid = filter.minifigUuid;
  nytFilter.lokationer = filter.lokationer;
  nytFilter.temaer = filter.temaer;
  nytFilter.kilder = filter.kilder;
  nytFilter.soegetekst = filter.soegetekst;
}

onBeforeMount(async () => {
  const nytFilter: Filter = defaultFilter();
  const value = localStorage.getItem(filterKey);
  if (value) {
    const gemtFilter: Filter = JSON.parse(value);
    klonFilter(gemtFilter, nytFilter);
  }
  if (
    (props.klodsUuid != undefined && props.klodsUuid != nytFilter.klodsUuid) ||
    (props.minifigUuid != undefined &&
      props.minifigUuid != nytFilter.minifigUuid)
  ) {
    nytFilter.klodsUuid = props.klodsUuid;
    nytFilter.minifigUuid = props.minifigUuid;
    nytFilter.soegetekst = "";
  }
  filter.value = nytFilter;
  searchValue.value = filter.value.soegetekst;
  const tokenKey = "accesstoken";
  await useAuth0()
    .getAccessTokenSilently()
    .then(response => {
      accesstoken.value = response;
      localStorage.setItem(tokenKey, response);
    })
    .catch(error => {
      console.error("Fejl ved hent af token: " + error);
      localStorage.removeItem(tokenKey);
      accesstoken.value = undefined;
    });
});

onMounted(async () => {
  webdav
    .getDirectoryContents(`/`, { glob: "[0-9]*-[0-9]*" })
    .then(
      results => (egneBilleder.value = results.map(mappe => mappe.basename))
    )
    .catch(err => console.error(err));
});
onBeforeRouteLeave(() => {
  const key = "legoinventory.filter";
  localStorage.setItem(key, JSON.stringify(filter.value));
});

watch(searchValue, tekst => {
  if (tekst?.length == 0) soeg("");
});

watch(accesstoken, token => {
  if (token == undefined)
    useAuth0().logout({ returnTo: window.location.origin });
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("aside", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("article", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_unref(kilderLoading))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Indlæser... "))
                  : (_openBlock(), _createElementBlock("form", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          id: "egnebilleder",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.checkMapper) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, filter.value.checkMapper]
                        ]),
                        _hoisted_12
                      ])
                    ]))
              ])
            ])
          ])
        ]),
        (accesstoken.value != undefined)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(Lokationsfilter, {
                lokationer: filter.value.lokationer,
                onUpdate: opdaterLokationer
              }, null, 8, ["lokationer"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("article", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                (_unref(kilderLoading))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Indlæser... "))
                  : (_openBlock(), _createElementBlock("form", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(muligeKilder), (kilde) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: kilde.navn
                        }, [
                          _createElementVNode("label", _hoisted_21, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "checkbox",
                              id: kilde.navn,
                              value: kilde.navn,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.kilder) = $event))
                            }, null, 8, _hoisted_22), [
                              [_vModelCheckbox, filter.value.kilder]
                            ]),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(kilde.navn), 1)
                          ])
                        ]))
                      }), 128))
                    ]))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("article", _hoisted_25, [
            _createElementVNode("header", _hoisted_26, [
              _createElementVNode("h6", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("span", _hoisted_29, [
                  _createElementVNode("a", { onClick: nulstilTemafilter }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("form", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(temaer), (tema) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mx-1",
                      key: tema.id
                    }, [
                      (tema.temasUndertemaTil?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createVNode(TemaElement, {
                              tema: tema,
                              checked: filter.value.temaer.includes(tema.navn),
                              onCheck: _cache[3] || (_cache[3] = v => checkbox(v))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tema.temasUndertemaTil, (undertema) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: undertema.id
                                  }, [
                                    _createElementVNode("label", _hoisted_33, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: undertema.id,
                                        value: tema.navn + '>' + undertema.navn,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.temaer) = $event))
                                      }, null, 8, _hoisted_34), [
                                        [_vModelCheckbox, filter.value.temaer]
                                      ]),
                                      _createElementVNode("span", _hoisted_35, _toDisplayString(undertema.navn), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["tema", "checked"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("label", _hoisted_38, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "form-check-input",
                                  type: "checkbox",
                                  id: tema.id,
                                  value: tema.navn,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filter.value.temaer) = $event))
                                }, null, 8, _hoisted_39), [
                                  [_vModelCheckbox, filter.value.temaer]
                                ]),
                                _createElementVNode("span", _hoisted_40, [
                                  _createTextVNode(_toDisplayString(tema.navn) + " ", 1),
                                  (tema.antalSet > 0)
                                    ? (_openBlock(), _createElementBlock("small", _hoisted_41, " (" + _toDisplayString(tema.antalSet) + ") ", 1))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ])
                          ]))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control me-2",
                type: "search",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchValue).value = $event)),
                onKeypress: _withKeys(onEnter, ["enter"]),
                placeholder: "Sætnummer eller titel..."
              }, null, 40, _hoisted_46), [
                [_vModelText, searchValue.value]
              ]),
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: soeg,
                type: "button"
              }, " Søg ")
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              (!_unref(klodsLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                    (_unref(klods) && filter.value.klodsUuid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("a", {
                            class: "text-decoration-none",
                            role: "button",
                            onClick: nulstilKlodsUuidFilter
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] }),
                            (_unref(klods).url != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                  _createElementVNode("img", {
                                    class: "img-fluid",
                                    style: {"float":"left","width":"75px","height":"50px","min-width":"75px","min-height":"50px","object-fit":"contain"},
                                    src: _unref(klods).url,
                                    alt: _unref(klods).navn
                                  }, null, 8, _hoisted_52)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_53, _toDisplayString(_unref(klods).navn), 1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!_unref(minifigLoading))
                ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                    (_unref(minifig) && filter.value.minifigUuid)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("a", {
                            class: "text-decoration-none",
                            role: "button",
                            onClick: nulstilMinifigUuidFilter
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'xmark'] }),
                            (_unref(minifig).url != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                  _createElementVNode("img", {
                                    class: "img-fluid",
                                    style: {"float":"left","width":"75px","height":"50px","min-width":"75px","min-height":"50px","object-fit":"contain"},
                                    src: _unref(minifig).url,
                                    alt: _unref(minifig).navn
                                  }, null, 8, _hoisted_57)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(_unref(minifig).navn), 1))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", { class: "ms-auto" }, [
                _createElementVNode("button", {
                  class: "btn btn-link btn-sm",
                  onClick: nulstilAlleFiltre
                }, _hoisted_60)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            (_unref(saetLoading))
              ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(filtreretOgSorteret), (legosaet) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: legosaet.uuid,
                    class: "card shadow-sm m-1",
                    style: {"width":"200px"}
                  }, [
                    _createVNode(LegoSetCard, {
                      legosaet: legosaet,
                      onSettema: vaelgTema
                    }, null, 8, ["legosaet"])
                  ]))
                }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})